import { ArchivedGroupsList } from 'presentation/app/modules/Groups/pages/archived-groups-list';

export const MakeArchivedGroupsList: React.FC = () => {
  return <ArchivedGroupsList />;
};
